import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/context/ToastContext";

export const NotFound = () => {
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    console.log(location.pathname);
    toast.error("Error: Page not found");
    navigate("/shop");
  }, [navigate, toast]);

  return null;
};
